export default __webpack_public_path__ + "static/media/tn_rep.b8cd9b49.png";